var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "h-9 rounded flex items-center overflow-hidden doc-page-controller",
    },
    [
      _vm.hasDraw || _vm.isRoomMode("CBT")
        ? _c("button", {
            staticClass: "button bg-arrow-left-white",
            on: {
              click: function ($event) {
                return _vm.movePage(_vm.doc.currDocPageSeq - 1, -1)
              },
            },
          })
        : _vm._e(),
      _c(
        "form",
        {
          staticClass: "h-full px-2 py-1.5 flex items-center",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.movePage.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { ref: "pageInputSizer", staticClass: "input-sizer" }, [
            _c("input", {
              ref: "pageInput",
              staticClass:
                "h-full rounded bg-white text-center input-hide-arrow",
              attrs: {
                type: "number",
                min: "1",
                max: _vm.maxPage,
                disabled: !_vm.hasDraw,
              },
              domProps: {
                value:
                  _vm.doc.currDocPageSeq ||
                  (_vm.$refs.pageInput && _vm.$refs.pageInput.value),
              },
              on: {
                input: function ($event) {
                  $event.stopPropagation()
                  return _vm.input.apply(null, arguments)
                },
                keyup: function ($event) {
                  $event.stopPropagation()
                  return _vm.keyup.apply(null, arguments)
                },
              },
            }),
          ]),
          _c("span", { staticClass: "mx-1.5 text-xs text-gray-100" }, [
            _vm._v("/"),
          ]),
          _c("p", { staticClass: "text-xs text-gray-100" }, [
            _vm._v(_vm._s(_vm.maxPage)),
          ]),
        ]
      ),
      _vm.hasDraw || _vm.isRoomMode("CBT")
        ? _c("button", {
            staticClass: "button bg-arrow-right-white",
            on: {
              click: function ($event) {
                return _vm.movePage(_vm.doc.currDocPageSeq + 1, 1)
              },
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }